const BASE_URL = "https://api.automa.id/api";

const CARBON_LOGGER_SCOPE1 = BASE_URL + '/dashboard/transporter/carbon/logger/scope1/transport/all'
// const CARBON_LOGGER_SCOPE3 = BASE_URL + '/dashboard/transporter/carbon/logger/scope3/transport'
const CARBON_LOGGER_SCOPE3 = BASE_URL + '/dashboard/transporter/carbon/logger/scope3/transport/all'

export {
    CARBON_LOGGER_SCOPE1,
    CARBON_LOGGER_SCOPE3
}